export const DATE_MEDIUM_FORMATTER = new Intl.DateTimeFormat('en-US', {
	dateStyle: 'medium',
	timeZone: 'UTC',
})

export const TIME_TWO_DIGIT_FORMATTER = new Intl.DateTimeFormat('en-US', {
	hour: '2-digit',
	minute: '2-digit',
	hour12: false,
	timeZone: 'UTC',
})
